import React from "react";
import { useTranslation } from "react-i18next";
import { Widget } from "@typeform/embed-react";
import { FormCard } from "@/components/FormCard";
import { constants } from "@/constants";
import { useProtectedNavigation } from "@/routes/useProtectedNavigation";

export const GameSubmit = () => {
  const { t } = useTranslation();
  const { navToRoute } = useProtectedNavigation();

  return (
    <FormCard
      title={t("editEvent.game.cardTitle")}
      description={t("editEvent.game.cardDescription")}
      className="w-full max-w-5xl"
      previousButton={{
        label: t("global.previous"),
        onClick: () => navToRoute("editEvent"),
        variant: "outline",
      }}
      cancelButton={{
        label: t("global.cancel"),
        onClick: () => navToRoute("communityTools"),
        variant: "outline",
      }}
    >
      {constants?.TYPEFORM_AUTOMATED_GAMES_ID && (
        <div className="relative my-10 h-[450px] min-h-[450px] w-full">
          <Widget
            id={constants.TYPEFORM_AUTOMATED_GAMES_ID}
            className="h-full w-full"
            onSubmit={() => navToRoute("communityTools")}
          />
        </div>
      )}
    </FormCard>
  );
};
